module.exports = __webpack_public_path__ + "static/credit-card-f383d1c434408a024a1f9bccccdf9ddc.svg";